// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store';
import axios from '@/lib/axios.js';
import iView from 'iview';
// import 'iview/dist/styles/iview.css';
import '@/styles/theme.less';
import '@/styles/giraffe.less';

Vue.use(iView);
Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$get', { value: axios.get });
Object.defineProperty(Vue.prototype, '$post', { value: axios.post });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js